import React from 'react';

// Renders a list of jump-links from a document's `sections` array.
// Each section: { id, order, anchor, heading, level }. Clicking a link scrolls
// to the matching heading id rendered by the document body.
const TableOfContents = ({ sections = [], className = '' }) => {
  if (!sections || sections.length === 0) return null;

  // Normalise levels so the shallowest heading sits flush-left regardless of
  // whether the source starts at h1 or h2.
  const minLevel = sections.reduce(
    (min, s) => Math.min(min, s.level || 1),
    Number.POSITIVE_INFINITY,
  );

  return (
    <nav className={className} aria-label="Table of contents">
      <p className="text-xs font-semibold uppercase tracking-wider text-gray-400 dark:text-gray-500 mb-2">
        On this page
      </p>
      <ul className="space-y-1 text-sm">
        {sections.map((section) => {
          const depth = Math.max(0, (section.level || 1) - minLevel);
          return (
            <li key={section.id ?? section.anchor}>
              <a
                href={`#${section.anchor}`}
                style={{ paddingLeft: `${depth * 0.75}rem` }}
                className="block py-0.5 text-gray-600 dark:text-gray-400 hover:text-primary-600 dark:hover:text-primary-400 transition-colors break-words"
              >
                {section.heading}
              </a>
            </li>
          );
        })}
      </ul>
    </nav>
  );
};

export default TableOfContents;
